import dynamic from 'next/dynamic'

import capitializeFirstChar from './capitializeFirstChar'

const AwarenessSection = dynamic(() => import('../components/AwarenessSection'))
const DealCard = dynamic(() => import('../components/DealCard'))
const Destinations = dynamic(() => import('../components/Destinations'))
const LocalMarketingSection = dynamic(() =>
	import('../components/LocalMarketingSection'),
)
const NowTrending = dynamic(() => import('../components/NowTrending'))
const OfficialPartners = dynamic(() => import('../components/OfficialPartners'))
const PackagesSection = dynamic(() => import('../components/PackagesSection'))
const Pills = dynamic(() => import('../components/Pills'))
const ThemedVacations = dynamic(() => import('../components/ThemedVacations'))

const getComponents = ({
	type,
	data,
	title,
	sliderBanner,
	openSignUp,
	setSignUp,
	setShowGlobalVideo,
	mobileDevice,
	region,
}) => {
	const component = capitializeFirstChar(type)

	switch (component) {
		case 'OfficialPartners': {
			return <OfficialPartners isMobile={mobileDevice} />
		}
		case 'AwarenessSection': {
			return <AwarenessSection isMobile={mobileDevice} />
		}
		case 'LocalMarketingSection': {
			return (
				<LocalMarketingSection
					title={'Why choose Pickyourtrail?'}
					themes={(data?.desktop || []).map(({ src, ...rest }) => ({
						src,
						...rest,
					}))}
					setShowGlobalVideo={setShowGlobalVideo}
					isMobile={mobileDevice}
				/>
			)
		}
		case 'PackagesSection': {
			return <PackagesSection isMobile={mobileDevice} />
		}
		case 'Destinations': {
			return <Destinations {...data} isMobile={mobileDevice} region={region} />
		}
		case 'ThemedVacations': {
			return <ThemedVacations {...data} isMobile={mobileDevice} />
		}
		case 'NowTrending': {
			return (
				<NowTrending
					isMobile={mobileDevice}
					trendingData={mobileDevice ? data?.mobile : data?.desktop}
				/>
			)
		}
		case 'DealCard': {
			return <DealCard {...data} isMobile={mobileDevice} />
		}
		case 'Pills': {
			return <Pills {...data} isMobile={mobileDevice} />
		}
		default:
			return null
	}
}

export default getComponents
